import { useContext } from 'react';
import { Context, ContextValue } from './context';

export const useInvoice = (): ContextValue => useContext(Context);
